<template>
  <div class="order-gift-operation" v-loading="loading">
    <co-fold-block title="基本信息">
      <el-form ref="basic" :model="formModel" :rules="formRules" label-width="130px" label-position="left">
        <el-form-item label="活动名称" prop="activity_title">
          <el-input v-model="formModel.activity_title" />
        </el-form-item>
        <el-form-item label="活动说明" prop="activity_description">
          <el-input type="textarea" maxlength="200" :rows="3" v-model="formModel.activity_description" />
        </el-form-item>
        <el-form-item label="活动开始时间" prop="activity_begin_time">
          <el-date-picker
            v-model="formModel.activity_begin_time"
            type="datetime"
            value-format="timestamp"
            :disabled="isEdit">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="活动结束时间" prop="activity_end_time">
          <el-date-picker
            v-model="formModel.activity_end_time"
            type="datetime"
            value-format="timestamp"
            :picker-options="{
              disabledDate(time) {
                return time.getTime() < Date.now() - 8.64e7
              }
            }">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="可参与范围" prop="user_scope">
          <el-radio-group v-model="formModel.user_scope" :disabled="isEdit" @input="handleUserScopeChange">
            <el-radio-button label="all">全部用户</el-radio-button>
            <el-radio-button label="vip">仅会员</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="formModel.user_scope == 'vip'" label="非会员可进行注册" prop="user_scope">
          <el-radio-group v-model="formModel.allow_registration" >
            <el-radio-button label="1">是</el-radio-button>
            <el-radio-button label="0">否</el-radio-button>
          </el-radio-group>
          <span style="color: #e6a23c;margin-left: 20px;">（修改非会员可进行注册，请重新编辑模版关联此活动）</span>
        </el-form-item>
        <el-form-item v-if="formModel.user_scope == 'vip' && formModel.allow_registration == '1'" label="引导注册渠道" prop="register_source_id">
          <div class="channel-select">
            <el-select v-model="formModel.register_source_id" filterable placeholder="请输入或选择">
              <el-option
                v-for="channel in channelOptions"
                :key="channel.channel_id"
                :label="channel.channel_name"
                :value="channel.channel_id"
              >
              </el-option>
            </el-select>
            <el-popover
              placement="bottom-start"
              width="350"
              v-model="channelVisible">
              <div style="display: flex;align-items: center">
                <div style="margin-right: 8px;">注册渠道名称：</div>
                <div><el-input v-model="channel_name" /></div>
              </div>
              <div style="text-align: right; margin-top: 12px;">
                <el-button size="mini" @click="channelVisible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="handleAddChannel">提交</el-button>
              </div>
              <el-button slot="reference" type="text" style="margin-left: 8px;">新增渠道</el-button>
            </el-popover>
            <el-popover
              placement="bottom-start"
              width="400"
              trigger="hover"
              content="注册渠道用于记录会员通过哪个渠道进入小程序完成注册，并且可以用于设置页面内容(热区图)时可针对通过指定渠道注册会员可见">
              <i class="el-icon-question" slot="reference"></i>
            </el-popover>
          </div>
        </el-form-item>
        <el-form-item label="活动规则标题" prop="activity_rule_title">
          <el-input v-model="formModel.activity_rule_title" />
        </el-form-item>
        <el-form-item label="活动规则描述" prop="activity_rule_desc">
          <el-input type="textarea" :rows="3" v-model="formModel.activity_rule_desc" />
        </el-form-item>
      </el-form>
    </co-fold-block>
    <co-fold-block title="会员权益可发放订单条件设置">
      <el-form ref="condition" :model="formModel" :rules="formRules" label-width="130px" label-position="left">
        <el-form-item label="可领取下单时间" prop="order_time">
          <el-date-picker
            v-model="formModel.order_time"
            type="datetimerange"
            value-format="timestamp"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <div class="form-item-desc">指定时间内下单的平台订单适用</div>
        <el-form-item label="可领取下单平台" prop="source">
          <el-checkbox-group v-model="formModel.source">
            <el-checkbox v-for="item in platLists" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="可领取订单门店" prop="order_shop">
          <div class="tip-color">平台订单的履约门店需在指定门店中方可领取，不传门店即为不限门店，活动保存后在列表中上传门店</div>
        </el-form-item>
        <el-form-item prop="isValidSwitch" label="是否校验短信验证码"  width="100">
          <template>
            <el-switch v-model="formModel.activity_open_check"  :active-value=1 :inactive-value=0 active-color="#13ce66" inactive-color="#cccccc" />
          </template>
        </el-form-item>
        <el-form-item v-if="formModel.user_scope == 'vip'" prop="check_member_no" label="校验会员编号"  width="100">
          <template>
            <el-switch v-model="formModel.check_member_no"  :active-value=1 :inactive-value=0 active-color="#13ce66" inactive-color="#cccccc" />
          </template>
        </el-form-item>
        <el-form-item  label="仓发是否参加"  width="100">
          <template>
            <el-switch v-model="formModel.warehouse_join"  :active-value=1 :inactive-value=0 active-color="#13ce66" inactive-color="#cccccc" />
          </template>
        </el-form-item>
        <el-form-item label="参与订单标签" prop="order_label">
          <el-checkbox-group v-model="formModel.order_label">
            <el-checkbox v-for="item in orderLabels" :label="item.value" :key="item.value">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="formModel.user_scope == 'vip'" label="消耗积分">
          <div style="display: flex;">
            <el-input-number
              v-model="formModel.points_consumption"
              :controls="false"
              :min="0"
              :precision="0"
              placeholder="请输入"
            />
            <span class="ml-12">请输入大于0的整数</span>
          </div>
        </el-form-item>
        <el-form-item label="可领取订单商品" prop="item_ids">
          <OrderGoods v-model="formModel.item_ids" />
          <div class="tip-color">平台订单中适用赠券的商品，按照订单中购买的赠券商品的数量赠券</div>
        </el-form-item>
      </el-form>
    </co-fold-block>
    <co-fold-block title="活动权益设置">
      <el-form ref="equity" :model="formModel" :rules="formRules" label-width="150px" label-position="left">
        <el-form-item label="权益类型" prop="interests_type">
          <el-radio-group v-model="formModel.interests_type" :disabled="isEdit">
            <el-radio-button v-for="item of ITEM_STATUS_OPTIONS" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>">
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="onlyShowWarranty" label="保修服务名称" prop="service_name">
          <el-input v-model="formModel.service_name" />
        </el-form-item>
        <el-form-item v-if="onlyShowCoupon" label="发放时间" prop="send_day">
          <div style="display: flex;">
            <span class="mr-12">订单完成</span>
            <el-input-number
              v-model="formModel.send_day"
              :controls="false"
              :min="0"
              :precision="0"
              placeholder="请输入"
            />
            <span class="ml-12">天后发放</span>
          </div>
        </el-form-item>
        <el-form-item v-if="onlyShowCoupon" label="选择优惠券" prop="coupon">
          <Coupon v-model="formModel.coupon"/>
        </el-form-item>
        <el-form-item v-if="onlyShowCoupon" label="优惠券领取方式" prop="coupon_get_type">

          <el-radio-group v-model="formModel.coupon_get_type" >
            <el-radio label="1">全部领取</el-radio>
            <el-radio label="2">多选一领取</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="onlyShowCoupon" label="可领取时效" prop="receive_term">
          <div style="display: flex;">
            <span class="mr-12">订单签收/核销后</span>
            <el-input-number
              v-model="formModel.receive_term"
              :controls="false"
              :min="0"
              :precision="0"
              placeholder="请输入"
            />
            <span class="ml-12">天内可领取</span>
          </div>
        </el-form-item>
        <el-form-item v-if="onlyShowWarranty" label="服务评价" prop="service_assessments">
          <el-input :value="formModel.associated_questionnaire_name" placeholder="请选择" clearable @focus="handleSelectServiceAss" @clear="handleClearServiceAss"/>
        </el-form-item>
        <el-form-item v-if="onlyShowWarranty && formModel.associated_questionnaire" label="可评价时效" prop="evaluate_term" >
          <div style="display: flex;">
            <span class="mr-12">取机后</span>
            <el-input-number
              v-model="formModel.evaluate_term"
              :controls="false"
              :min="0"
              :precision="0"
              placeholder="请输入"
            />
            <span class="ml-12">天内可评价</span>
          </div>
        </el-form-item>
        <el-form-item v-if="onlyShowWarranty" label="保修有效期" prop="maintenance_day">
          <div style="display: flex;">
            <span class="mr-12">绑定后</span>
            <el-input-number
              v-model="formModel.maintenance_day"
              :controls="false"
              :min="0"
              :precision="0"
              placeholder="请输入"
            />
            <span class="ml-12">天内有效</span>
          </div>
        </el-form-item>
        <el-form-item v-if="onlyShowWarranty" label="保修可绑定时效" prop="maintenance_term">
          <div style="display: flex;">
            <span class="mr-12">订单签收/核销后</span>
            <el-input-number
              v-model="formModel.maintenance_term"
              :controls="false"
              :min="0"
              :precision="0"
              placeholder="请输入"
            />
            <span class="ml-12">天内有效</span>
          </div>
        </el-form-item>
        <template v-if="onlyShowGift">
          <el-form-item label="赠品库存策略" prop="gift_inventory_strategy">
            <el-radio-group v-model="formModel.gift_inventory_strategy">
              <el-radio label="stock_item">赠完即止</el-radio>
              <el-radio label="none">不限库存</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="可领取开始时间" prop="start_claiming">
            <div style="display: flex;">
              <span class="mr-12">用户平台订单签收</span>
              <el-input-number
                v-model="formModel.start_claiming"
                :controls="false"
                :min="0"
                :precision="0"
                placeholder="请输入"
              />
              <span class="ml-12">*24小时后可领取（创建赠品订单）</span>
            </div>
          </el-form-item>
          <el-form-item label="可领取截止时间" prop="end_claiming">
            <div style="display: flex;">
              <span class="mr-12">用户平台订单签收后</span>
              <el-input-number
                v-model="formModel.end_claiming"
                :controls="false"
                :min="0"
                :precision="0"
                placeholder="请输入"
              />
              <span class="ml-12">天内（至最后一天23:59:59）</span>
            </div>
          </el-form-item>
          <div v-if="formModel.interests_type === 3">
            <el-form-item label="可核销开始时间" prop="start_verifiable_time" >
              <div style="display: flex;">
                <span class="mr-12">用户平台订单签收</span>
                <el-input-number
                  v-model="formModel.start_verifiable_time"
                  :controls="false"
                  :min="0"
                  :precision="0"
                  placeholder="请输入"
                />
                <span class="ml-12">*24小时后可核销（赠品完成备货后展示核销码）</span>
              </div>
            </el-form-item>
            <el-form-item label="可核销截止时间" prop="verifiable_time_type">
              <template v-slot:label>
                <span>
                  可核销截止时间
                  <el-popover trigger="hover" placement="top-start">
                    统一过期时间早于等于活动结束时间，可能导致部分用户无法领取
                    <i slot="reference" class="el-icon-info" />
                  </el-popover>
                </span>
              </template>
              <el-radio-group v-model="formModel.verifiable_time_type" @input="handleGiftTypeChange">
                <el-radio label="fixed">统一日期截止</el-radio>
                <el-radio label="day">用户可核销开始时间+n天截止</el-radio>
              </el-radio-group>
              <div>
                <el-date-picker
                  v-if="formModel.verifiable_time_type === 'fixed'"
                  v-model="formModel.verifiable_time"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  @change="handleDateChange"
                />
                <el-input-number
                  v-else
                  v-model="formModel.verifiable_time"
                  :controls="false"
                  :min="0"
                  :precision="0"
                  placeholder="请输入"
                  style="display: inline-block;"
                />
                <span class="ml-12">的 23:59:59 截止</span>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="卡密发放时间" prop="start_verifiable_time" v-if="formModel.interests_type === 4">
            <div style="display: flex;">
              <span class="mr-12">用户平台订单签收</span>
              <el-input-number
                v-model="formModel.start_verifiable_time"
                :controls="false"
                :min="0"
                :precision="0"
                placeholder="请输入"
              />
              <span class="ml-12">天后发放</span>
            </div>
          </el-form-item>
          <el-form-item :label="formModel.interests_type === 3 ? '实物赠品' : '虚拟赠品'" prop="gift_rel_data">
            <GiftGoods v-model="formModel.gift_rel_data" :giftType="onlyGiftType()"/>
          </el-form-item>
          <el-form-item label="赠品订单活动备注" prop="remark">
            <el-input v-model="formModel.remark" placeholder="请输入活动备注"/>
          </el-form-item>
        </template>
      </el-form>
    </co-fold-block>
    <co-fold-block title="活动模版配置">
      <el-form ref="template" :model="formModel" :rules="formRules" label-width="130px" label-position="left">
        <el-form-item label="订单校验模板" prop="activity_template">
          <el-button type="text" @click="handleCheckTemplate">{{ formModel.activity_template ? '查看模板' : '设置模板'}}</el-button>
        </el-form-item>
        <el-form-item label="信息确认页" prop="received_image">
          <el-button type="text" @click="handleReceived">{{ formModel.received_image ? '查看模板' : '设置模板'}}</el-button>
        </el-form-item>
        <el-form-item label="领取/绑定成功页" prop="bind_succ_img">
          <el-button type="text" @click="handleBindSucc">{{ formModel.bind_succ_img ? '查看模板' : '设置模板'}}</el-button>
        </el-form-item>
      </el-form>
    </co-fold-block>
    <FooterSubmitButtons @cancel="hanldeCancel" @submit="handleSubmit"/>
    <QuestionnaireSelect :visible="questionVisible" :radioId="formModel.associated_questionnaire" @saveAction="saveAction" @closeDialog="closeDialog" />
  </div>
</template>

<script>
import { create, update, detail, createChannel, getChannelList, getSourceList } from './api'
import { mapGetters } from 'vuex'
import FooterSubmitButtons from './component/footer-submit-buttons'
import OrderGoods from './component/order-goods'
import Coupon from './component/coupon'
import QuestionnaireSelect from '@/components/function/questionnaireSelect'
import { useDialog } from '@shopex/finder'
import GiftGoods from '@/view/mall/marketing/buyxgivey/comps/gift-goods'
import { ITEM_STATUS_OPTIONS } from './config'

export default {
  components: { FooterSubmitButtons, OrderGoods, Coupon, QuestionnaireSelect, GiftGoods },
  data () {
    return {
      loading: false,
      id: null,
      channelVisible: false,
      channel_name: '',
      platLists: [],
      orderLabels: [],
      ITEM_STATUS_OPTIONS,
      formModel: {
        activity_title: '',
        activity_begin_time: '',
        activity_end_time: '',
        register_source_id: '1',
        order_time: [],
        source: [],
        activity_open_check:0,
        warehouse_join:0,
        item_ids: [],
        activity_template: null,
        user_scope: 'all',
        interests_type: 1,
        service_name: '',
        received_image: null,
        bind_succ_img: null,
        associated_questionnaire: '',
        associated_questionnaire_name: '',
        send_day: 7,
        coupon: [],
        receive_term: 0,
        coupon_get_type: "1",//1全部领取 2 领取一种
        evaluate_term: 30,
        maintenance_day: 0,
        maintenance_term: 14,
        gift_inventory_strategy: 'stock_item',
        start_claiming: undefined,
        end_claiming: undefined,
        start_verifiable_time: undefined,
        verifiable_time_type: 'fixed',
        verifiable_time: undefined,
        gift_rel_data: [],
        remark: '',
        activity_rule_title: '',
        activity_rule_desc: '',
        order_label: [],
        allow_registration: '1', // 非会员是否可注册会员
        points_consumption: '', // 消耗的积分
        check_member_no: 0,
        activity_description: '' // 活动说明
      },
      formRules: {
        activity_title: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        activity_begin_time: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        activity_end_time: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        register_source_id:  [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        activity_template: [
          { required: true, message: '请设置', trigger: 'change' }
        ],
        order_time: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        source: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        order_label: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        item_ids: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        service_name: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        received_image: [
          { required: true, message: '请设置', trigger: 'change' }
        ],
        bind_succ_img: [
          { required: true, message: '请设置', trigger: 'change' }
        ],
        send_day: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        coupon: [
          { required: true, message: '请选择', trigger: 'change' }
        ],
        receive_term: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        evaluate_term: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        maintenance_day: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        maintenance_term: [
          { required: true, message: '请输入', trigger: 'change' }
        ],
        gift_inventory_strategy: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        start_claiming: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        end_claiming: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        start_verifiable_time: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        verifiable_time_type: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        gift_rel_data: [
          { required: true, message: '请选择', trigger: 'blur' },
        ],
        activity_rule_title: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
        activity_rule_desc: [
          { required: true, message: '请输入', trigger: 'blur' },
        ],
      },
      channelOptions: [],
      questionVisible: false,
    }
  },
  computed: {
    ...mapGetters([
      'wheight',
      'wxapp_id',
      'template_name'
    ]),
    onlyShowCoupon() {
      return this.formModel.interests_type === 1
    },
    onlyShowWarranty() {
      return this.formModel.interests_type === 2
    },
    onlyShowGift() {
      return this.formModel.interests_type === 3 || this.formModel.interests_type === 4
    },
    isEdit() {
      return !!this.id
    }
  },
  async mounted() {
    this.getChannel()
    this.getSourceList()

    const id = this.$route.query.id
    if(id) {
      this.id = id
      this.initDetail()
    }else{
      //默认仓库加入活动开关默认开启
      this.formModel.warehouse_join = 1
    }
  },
  methods: {
    async initDetail() {
      try {
        this.loading = true
        const res = await detail(this.id)
        let { data } = res.data
        data = this.formatTimeBy1000('up', data)
        this.formModel = Object.assign(this.formModel, data)
        this.formModel.order_time = [data.order_begin_time, data.order_end_time]
        this.formModel.item_ids = data.items?.map(item => ({
          item_id: item.item_id,
          item_name: item.item_name,
          item_bn: item.item_bn,
          item_spec_desc: item.item_spec_desc,
          isValidSwitch: item.isValidSwitch,
          isValidSwitchWareHouse: item.isValidSwitchWareHouse??false,
        }))
        this.formModel.activity_template = JSON.parse(data.activity_template)
        const { received_image, card_list, bind_succ_img, gift_list } = data.gifts[0].interests_info
        this.formModel = Object.assign(this.formModel, data.gifts[0].interests_info)
        if(received_image) {
          this.formModel.received_image = received_image
        }
        if(bind_succ_img) {
          this.formModel.bind_succ_img = bind_succ_img
        }
        this.formModel.coupon = card_list
        this.formModel.gift_rel_data = gift_list
      } catch (e) {
        console.log("🚀🚀🚀🚀🚀🚀 ~ initDetail ~ e:", e)
      } finally {
        this.loading = false
      }
    },
    /** 新增渠道 */
    async handleAddChannel() {
      if(!this.channel_name) return
      await createChannel(this.channel_name)
      this.$message.success('添加成功')
      this.getChannel()
      this.channel_name = ''
      this.channelVisible = false
    },

    /** 获取渠道列表 */
    async getSourceList() {
      console.log( this.platLists)

      let res = await getSourceList()
      this.platLists  ={};
      console.log( res.data.data)
      let sourceList = res.data.data.sourceList
      let orderLabels = res.data.data.orderLabels
      const result = [];
      const result2 = [];

      for (let label in sourceList) {
        result.push({ label: sourceList[label], value: label  });

      }
      for (let label in orderLabels) {
        result2.push({ label: orderLabels[label], value: label  });

      }
      this.platLists = result;
      this.orderLabels = result2;


    },
    async getChannel() {
      const res = await getChannelList()
      const { data: { list } }  = res.data
      this.channelOptions = list
    },
    handleSelectServiceAss() {
      this.questionVisible = true
    },
    handleClearServiceAss() {
      this.formModel.associated_questionnaire = ''
      this.formModel.associated_questionnaire_name = ''
    },
    /** 订单校验模板 */
    handleCheckTemplate() {
      useDialog(null, {
        title: `订单校验模板`,
        width: '80%',
        activity_template: this.formModel.activity_template,
        component: () => import('./component/check-template.vue'),
        actions:  [
          { label: '取消', key: 'close', size: 'default' },
          { label: '确定', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(arg => {
        if(arg) {
          this.formModel.activity_template = arg
        }
      })
    },
    handleReceived(){
      useDialog(null, {
        title: `信息确认模板`,
        width: '80%',
        type: 'received_image',
        templateData: this.formModel.received_image,
        component: () => import('./component/info-template.vue'),
        actions:  [
          { label: '取消', key: 'close', size: 'default' },
          { label: '确定', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(arg => {
        if(arg) {
          this.formModel.received_image = arg
        }
      })
    },
    handleBindSucc() {
      useDialog(null, {
        title: `领取/绑定成功模板`,
        width: '80%',
        type: 'bind_succ_img',
        templateData: this.formModel.bind_succ_img,
        component: () => import('./component/info-template.vue'),
        actions:  [
          { label: '取消', key: 'close', size: 'default' },
          { label: '确定', key: 'save', type: 'primary', size: 'default' }
        ]
      }).then(arg => {
        if(arg) {
          this.formModel.bind_succ_img = arg
        }
      })
    },
    // 调查问卷选择结果
    saveAction (data) {
      this.closeDialog()
      if (!data?.length) return
      this.formModel.associated_questionnaire = data[0].id
      this.formModel.associated_questionnaire_name = data[0].tpl_name
    },
    closeDialog () {
      this.questionVisible = false
    },
    hanldeCancel() {
      this.$router.go(-1)
    },
    handleGiftTypeChange() {
      // 每次切换清空
      this.formModel.verifiable_time = undefined
    },
    /**
     * @desc 根据时间戳格式化到s
     * @param {String} type up *1000 |  down /1000
     * @param {Object} data
    */
    formatTimeBy1000(type, obj) {
      switch (type) {
        case 'up':
          if(obj.activity_begin_time) obj.activity_begin_time = Number(obj.activity_begin_time) * 1000
          if(obj.activity_end_time) obj.activity_end_time = Number(obj.activity_end_time) * 1000
          if(obj.order_begin_time) obj.order_begin_time = Number(obj.order_begin_time) * 1000
          if(obj.order_end_time) obj.order_end_time = Number(obj.order_end_time) * 1000
          return obj
        case 'down':
          if(obj.activity_begin_time) obj.activity_begin_time = Number(obj.activity_begin_time) / 1000
          if(obj.activity_end_time) obj.activity_end_time = Number(obj.activity_end_time) / 1000
          if(obj.order_begin_time) obj.order_begin_time = Number(obj.order_begin_time)  / 1000
          if(obj.order_end_time) obj.order_end_time = Number(obj.order_end_time)  / 1000
          return obj
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.basic.validate()
        await this.$refs.condition.validate()
        await this.$refs.equity.validate()
        const { order_time, coupon, item_ids, received_image, bind_succ_img, activity_template, gift_rel_data } = this.formModel
        // 活动的公众号组件仅可添加一个
        let received_image_acc = 0
        received_image.forEach(item => {
          if(item.account) {
            received_image_acc += 1
          }
        });
        let bind_succ_img_acc = 0
        bind_succ_img.forEach(item => {
          if(item.account) {
            bind_succ_img_acc += 1
          }
        });
        let activity_template_acc_vip = 0
        let activity_template_acc_novip = 0
        Object.keys(activity_template).forEach(key => {
          Object.keys(activity_template[key]).forEach(skey => {
            const sdata = activity_template?.[key]?.[skey]
            if(Array.isArray(sdata)) {
              sdata?.forEach(item => {
                if(skey === 'vip' && item?.account?.type === 'hasAcc') {
                  activity_template_acc_vip += 1
                } else if(skey === 'novip' && item?.account?.type === 'hasAcc') {
                  activity_template_acc_novip += 1
                }
              })
            }
          })
        })
        let accText = ''
        if(received_image_acc) {
          accText += '信息确认页,'
        }
        if(bind_succ_img_acc) {
          accText += '领取/绑定成功页,'
        }
        if(activity_template_acc_vip || activity_template_acc_novip) {
          accText += '订单校验模板,'
        }
        accText = accText.slice(0, -1)
        accText += '都存在公众号组件,公众号组件仅可添加一个'
        const total_acc_vip = received_image_acc + bind_succ_img_acc + activity_template_acc_vip
        const total_acc_novip = received_image_acc + bind_succ_img_acc + activity_template_acc_novip
        if(total_acc_vip > 1 || total_acc_novip > 1) {
          this.$message.error(accText)
          return
        }
        let data = {
          ...this.formModel,
          order_begin_time: order_time[0],
          order_end_time: order_time[1],
          activity_template: JSON.stringify(activity_template),
          received_image: JSON.stringify(received_image),
          bind_succ_img: bind_succ_img ? JSON.stringify(bind_succ_img) : '',
          card_id: coupon?.map(item => item.card_id).join(),
          item_ids: item_ids.map(item => (item.item_id + '_' + item.isValidSwitch)),
          gift_id: gift_rel_data?.map(item => item.item_id).join()
        }
        data = this.formatTimeBy1000('down', data)
        // 删除无用字段
        delete data.coupon
        delete data.gifts
        delete data.items
        delete data.card_list
        delete data.gift_rel_data

        this.loading = true
        if(this.id) {
          data.id = this.id
          await update(data)
        } else {
          await create(data)
        }
        this.$message.success('保存成功')
        this.hanldeCancel()
      } finally{
        this.loading = false
      }
    },
    handleDateChange(v) {
      this.formModel.verifiable_time = `${v} 23:59:59`
    },
    onlyGiftType() {
      return this.formModel.interests_type === 3 ? 'gift_normal' : 'gift_services'
    },
    handleUserScopeChange(val) {
      this.formModel.check_member_no = val == 'all' ? 0 : 1
    }
  }
}
</script>

<style scoped lang="scss">
.order-gift-operation {
  position: relative;
  ::v-deep .el-input {
    width: 250px;
  }
  ::v-deep .el-textarea {
    width: 250px;
  }
  ::v-deep .el-input-number {
    width: 100px;
    .el-input {
      width: 100px;
    }
  }
  .ml-12 {
    margin-left: 12px;
  }
  .mr-12 {
    margin-right: 12px;
  }
  .channel-select {
    display: flex;
  }
  .form-item-desc {
    margin-left: 120px;
    font-size: 12px;
    color: #909399;
  }
  .tip-color {
    color: #909399;
  }
  .temp-content {
    display: flex;
    flex-wrap: nowrap;
    .cell-start {
      color: #F56C6C;
    }
    &-left {
      width: 35%;
      min-width: 450px;
    }
    &-right {
      width: 35%;
      min-width: 450px;
      margin-left: 24px;
    }
    &-wrapper {
      border: 1px solid #e7e7eb;
      margin: 24px 0;
      &-title {
        padding: 0 12px;
        background-color: #edfefc;
        border-bottom: 1px solid #e7e7eb;
      }
      &-content {
        height: 200px;
        padding: 12px;
        display: flex;
        flex-direction: column;
        .el-form-item {
          margin: 10px 0;
        }
        ::v-deep .el-form-item__label:before {
          display: none;
        }
      }
      &-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #e7e7eb;
        padding: 0 12px;
        background-color: #edfefc;
        .set-name {
          width: calc(100% - 40px - 24px);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .set-path {
          color: #409eff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
